// extracted by mini-css-extract-plugin
export var details = "_el-0";
export var inspectorPopover = "_el-1";